"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _index = _interopRequireDefault(require("@/components/Store/AddEditStoreModel/index.vue"));
var _index2 = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    AddEditStoreModel: _index.default
  },
  data: function data() {
    var _this2 = this;
    return {
      loadingComponent: null,
      isLoading: false,
      btnLoading: false,
      // regionOptions: [],
      storeStructureOptions: [],
      ssbtypeOptions: [],
      daMethodOptions: [],
      tireSupplierOptions: [],
      accountMethodOptions: [],
      tyreBrandOptions: [],
      optConfig: {
        visitPurposeOptions: [],
        // 拜访目的select
        rtmOptions: [],
        // 门店RTM类型select
        storeCategoryOptions: [],
        // 客户类型select（零售店类别）
        tppOptions: [],
        // TPP签约量select
        storeStructureOptions: [],
        // 零售店性质select
        ssbtypeOptions: [],
        // 店招品牌select
        daMethodOptions: [],
        // 记账方式select
        tireSupplierOptions: [],
        // 主要进货渠道select
        accountMethodOptions: [],
        // 结算方式select
        tyreBrandOptions: [],
        // 轮胎品牌select
        mainserviceOptions: [] // 主要服务项目select
      },
      pageName: 'CPStoreList',
      // test 权限还没加，测试用
      region: [],
      city: [],
      area: [],
      /** enum */
      regionOptions: [],
      cityOptions: [],
      areaOptions: [],
      addressOptions: [],
      // 地址option
      addressTimer: null,
      // api timer
      shareScopeEnd: [],
      /** search group */
      props: {
        multiple: true,
        checkStrictly: true,
        multipleLimit: 3,
        value: 'label'
      },
      searchVal: {
        rtlSapId: '',
        // 客户编号
        rtlFullName: '',
        // 店名
        rtlRtmCategory: '',
        // RTM类型
        retailerTypeList: [],
        // 零售店类别
        rtlRegionList: [],
        // 省
        rtlCityList: [],
        // 市
        rtlDistrictList: [],
        // 区
        rtlAddress: '',
        // 地址
        empNo: '',
        // SR工号
        empName: '',
        // SR姓名
        signBoardBrand: '',
        // 店招品牌类型
        visitFrequency: '',
        // 拜访频率
        lastVisitStartTime: '',
        // 最近一次拜访 开始时间
        lastVisitEndTime: '',
        // 最近一次拜访 结束时间
        rebateBalance: '',
        // 返利结余
        lastPurchaseStartTime: '',
        // 最近一次进货时间
        lastPurchaseEndTime: '',
        // 最近一次进货时间
        visitType: '',
        // 拜访类型
        tppCpSign: '',
        tppGySign: '',
        contactsNameOne: '',
        // 门店联系人
        isBaiLian: '',
        // 是否为百炼转换
        planTaskStartMonth: '',
        planTaskEndMonth: '',
        gasnFlag: '' // GASN门店签约情况
      },
      exportTitle: '',
      exportType: '',
      gapMonth: 1,
      monthVisible: false,
      pickerMinDate: '',
      pickerOptions: {
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
            minDate = _ref.minDate;
          _this2.pickerMinDate = minDate;
          if (maxDate) {
            _this2.pickerMinDate = '';
          }
        },
        disabledDate: function disabledDate(time) {
          if (_this2.pickerMinDate !== "") {
            var currMonth = _this2.pickerMinDate.getMonth() + 1;
            var currYear = _this2.pickerMinDate.getFullYear();
            var minYear;
            var minMonth = currMonth - _this2.gapMonth;
            if (minMonth > 0) {
              minYear = currYear;
            } else {
              minYear = currYear - 1;
              minMonth = 12 + minMonth;
            }
            var minDate = new Date("".concat(minYear, " ").concat(minMonth));
            var maxYear;
            var maxMonth = currMonth + _this2.gapMonth;
            if (maxMonth > 12) {
              maxYear = currYear + 1;
              maxMonth = currMonth - 12;
            } else {
              maxYear = currYear;
            }
            var maxDate = new Date("".concat(maxYear, " ").concat(maxMonth));
            return time > maxDate || time < minDate;
          }
        }
      },
      /** table group */
      listLoading: false,
      currPage: 1,
      limit: 10,
      total: 0,
      list: [],
      sourceApi: null,
      // api timer

      form: {
        file: null
      },
      lookupList: {},
      lastVisitStartTimeOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > new Date();
        }
      },
      lastVisitEndTimeOptions: {
        disabledDate: function disabledDate(time) {
          if (_this2.searchVal.lastVisitStartTime) {
            return time.getTime() < new Date(_this2.searchVal.lastVisitStartTime).getTime() - 3600 * 1000 * 24;
          }
        }
      },
      lastPurchaseStartTimeOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > new Date();
        }
      },
      lastPurchaseEndTimeOptions: {
        disabledDate: function disabledDate(time) {
          if (_this2.searchVal.lastPurchaseStartTime) {
            return time.getTime() < new Date(_this2.searchVal.lastPurchaseStartTime).getTime() - 3600 * 1000 * 24;
          }
        }
      }
    };
  },
  computed: {
    startPickerOptions: function startPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          // 当end time 选择时，限制start time > end time
          var timeGetTime = time.getTime();
          if (_this.searchVal.endTime) {
            var now = new Date(_this.searchVal.endTime).getTime() - 24 * 60 * 60 * 1000;
            return timeGetTime > now;
          }
        }
      };
    },
    endPickerOptions: function endPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          // 当start time 选择时，限制end time < start time
          var timeGetTime = time.getTime();
          if (_this.searchVal.startTime) {
            var limitTime = new Date(_this.searchVal.startTime).getTime();
            return timeGetTime <= limitTime;
          }
        }
      };
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0)"
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode();
    }
  },
  mounted: function mounted() {
    this.fetchRegionList();
    // this.fetchData()
    this.getLookupTypeCode();
  },
  methods: {
    /** 省市区 enum */fetchRegionList: function fetchRegionList() {
      var _this3 = this;
      if (this.$store.getters.regionData.length) {
        this.regionOptions = this.$store.getters.regionData;
        return;
      }
      this.$api.common.getRegionList(3).then(function (response) {
        var responseData = response;
        if (responseData.success) {
          _this3.regionOptions = responseData.data;
          _this3.$store.dispatch('baseData/saveRegionData', responseData.data);
        }
      }).catch(function (error) {
        console.log('-----' + error);
      });
    },
    // resert table
    resetData: function resetData() {
      this.searchVal = this.$options.data().searchVal;
      this.region = [];
      this.city = [];
      this.area = [];
      this.provinceClearEvent();
      this.fetchData();
    },
    // search
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    /**
     * table methods
     */
    // get table list
    fetchData: function fetchData() {
      var _this4 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      this.listLoading = true;
      this.$api.CPRetailorStore.getList(param, this.sourceApi.token).then(function (res) {
        _this4.listLoading = false;
        _this4.list = res.data.items;
        _this4.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this4.listLoading = false;
      });
    },
    reportExport: function reportExport() {
      if (this.exportType === 'VISIT_REPORT') {
        this.downloadExcel('VISIT_REPORT', this.$t("CPStoreList.export.visitRecord"));
      } else if (this.exportType === 'TIRE_SALES') {
        this.downloadExcel('TIRE_SALES', this.$t("CPStoreList.export.otherInfo"));
      }
    },
    downloadExcel: function downloadExcel(type, name) {
      var _this5 = this;
      // if (type === "VISIT_REPORT" && !(this.searchVal.planTaskStartMonth && this.searchVal.planTaskEndMonth)) {
      //   this.$message.error('请先选择月份范围')
      //   return
      // }
      // this.isLoading = true
      this.btnLoading = true;
      this.searchVal['exportType'] = type;
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.$api.CPRetailorStore.export(param).then(function (res) {
        _this5.btnLoading = false;
        (0, _index2.downloadFileExcel)(name, res.data);
        _this5.monthVisible = false;
      }).catch(function () {
        _this5.btnLoading = false;
      });
    },
    regionSearchChangeEvent: function regionSearchChangeEvent(value) {
      console.log(value, 'regionSearchChangeEvent');
      if (!value) return;
      var regionCode = [];
      var cityCode = [];
      var districtCode = [];
      value.forEach(function (item) {
        console.log(item, 'item');
        if (item.length === 1) {
          regionCode = item[0];
        }
        if (item.length === 2) {
          cityCode = item[1];
        }
        if (item.length === 3) {
          districtCode = districtCode.concat(item[2]);
        }
      });
      this.searchVal.rtlRegionList = regionCode;
      this.searchVal.rtlCityList = cityCode;
      this.searchVal.rtlDistrictList = districtCode;
      this.changeLabel();
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this6 = this;
      var param = {
        configItemCodeList: ['STORE_RTM_TYPE', 'STORE_CATEGORY', 'STORE_STRUCTURE', 'MAIN_SERVICE_ITEMS', 'DETAILS_ACCOUNTING_METHOD', 'TIRE_SUPPLIER', 'ACCOUNTING_METHOD', 'STORE_SIGN_BRAND_TYPE', 'TYRE_BRAND', 'TPP_SIGN_ASC_GY', 'TPP_SIGN_ASC_CP', 'Y_OR_N', 'GASN_EXPIRATION_STORE']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        // 处理一下 Y_OR_N
        if (res.data && res.data.Y_OR_N) {
          res.data.Y_OR_N.forEach(function (item) {
            var newCode = item.code === 'Y';
            item.code = newCode;
          });
        }
        _this6.lookupList = JSON.parse(JSON.stringify(res.data || {}));
        _this6.optConfig.rtmOptions = _this6.lookupList['STORE_RTM_TYPE'];
        _this6.optConfig.ssbtypeOptions = _this6.lookupList['STORE_SIGN_BRAND_TYPE'];
        _this6.optConfig.daMethodOptions = _this6.lookupList['DETAILS_ACCOUNTING_METHOD'];
        _this6.optConfig.tireSupplierOptions = _this6.lookupList['TIRE_SUPPLIER'];
        _this6.optConfig.accountMethodOptions = _this6.lookupList['ACCOUNTING_METHOD'];
        _this6.optConfig.tyreBrandOptions = _this6.lookupList['TYRE_BRAND'];
        _this6.optConfig.storeCategoryOptions = _this6.lookupList['STORE_CATEGORY'];
        _this6.optConfig.mainserviceOptions = _this6.lookupList['MAIN_SERVICE_ITEMS'];
        _this6.optConfig.storeStructureOptions = _this6.lookupList['STORE_STRUCTURE'];

        // 查找值数据转换
        for (var key in _this6.lookupList) {
          _this6.generateMapping(key, _this6.lookupList[key] || []);
        }
        _this6.searchData();
      }).catch(function () {
        console.log('Data Request Fail');
      });
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this7 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this7.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    },
    // view item
    onView: function onView(row) {
      this.$router.push({
        path: '/storeModule/CPStoreList/storeDetails',
        query: {
          retailorStoreInfoPk: row.retailorStoreInfoPk
        }
      });
      // 跳转页面
    },
    // refresh daily table
    refreshTable: function refreshTable() {
      this.fetchData();
    },
    changeLabel: function changeLabel(val) {
      var _this8 = this;
      // 是否与上次的类型相同
      var changeFlag = false;
      var changeItem = null;
      if (this.shareScopeEnd.length === 0) {
        this.searchVal.area = val;
      } else {
        // 与原数组比对
        this.searchVal.area.forEach(function (item) {
          if (item[0] !== _this8.shareScopeEnd[0][0]) {
            // 一级标签不同
            changeFlag = true;
            changeItem = item;
          } else if (item[1] !== _this8.shareScopeEnd[0][1]) {
            // 一级标签相同但是二级标签不同
            changeFlag = true;
            changeItem = item;
          } else if (!item[2] && _this8.shareScopeEnd[0][2] || item[2] && !_this8.shareScopeEnd[0][2]) {
            changeFlag = true;
            changeItem = item;
          }
        });
      }
      if (changeFlag) {
        this.searchVal.area = [];
        this.searchVal.area.push(changeItem);
      }
      this.shareScopeEnd = this.searchVal.area;
      this.regionSearchChangeEvent(val);
    },
    pcdClearEvent: function pcdClearEvent() {
      this.region = [];
      this.city = '';
      this.area = '';
      this.cityOptions = [];
      this.areaOptions = [];
      this.searchVal.rtlRegionList = [];
      this.searchVal.rtlDistrictList = [];
      this.searchVal.rtlCityList = [];
    },
    pcdChangeEvent: function pcdChangeEvent(value) {
      var rtlRegionList = [];
      var rtlCityList = [];
      var rtlDistrictList = [];
      while (value.some(function (item) {
        console.log(item);
        if (item.length === 3) {
          if (rtlRegionList.indexOf(item[0]) === -1) {
            rtlRegionList.push(item[0]);
          }
          if (rtlCityList.indexOf(item[1]) === -1) {
            rtlCityList.push(item[1]);
          }
          if (rtlDistrictList.indexOf(item[2]) === -1) {
            rtlDistrictList.push(item[2]);
          }
        }
        // eslint-disable-next-line no-empty
      })) {}
      this.searchVal.rtlRegionList = rtlRegionList;
      this.searchVal.rtlCityList = rtlCityList;
      this.searchVal.rtlDistrictList = rtlDistrictList;
      console.log('=====val=====', value);
      // this.searchVal.rtlDistrictList = value
    },
    provinceChangeEvent: function provinceChangeEvent(value) {
      this.searchVal.rtlRegionList = [].concat(value.label);
      if (value.children && value.children.length > 0) {
        this.cityOptions = (0, _toConsumableArray2.default)(value.children);
      }
    },
    cityChangeEvent: function cityChangeEvent(value) {
      this.searchVal.rtlCityList = [].concat(value.label);
      if (value.children && value.children.length > 0) {
        this.areaOptions = (0, _toConsumableArray2.default)(value.children);
      }
    },
    areaChangeEvent: function areaChangeEvent(value) {
      while (value.some(function (item) {
        return Array.isArray(item);
      })) {
        value = [].concat.apply([], value);
      }
      this.searchVal.rtlDistrictList = value;
    },
    provinceClearEvent: function provinceClearEvent() {
      this.city = '';
      this.area = '';
      this.cityOptions = [];
      this.areaOptions = [];
      this.searchVal.rtlRegionList = [];
      this.searchVal.rtlDistrictList = [];
      this.searchVal.rtlCityList = [];
    },
    cityClearEvent: function cityClearEvent() {
      this.area = '';
      this.areaOptions = [];
      this.searchVal.rtlDistrictList = [];
    },
    areaClearEvent: function areaClearEvent() {
      this.searchVal.rtlDistrictList = [];
    },
    // 新开卡（新增门店）
    onAddStore: function onAddStore() {
      this.$refs['addEditStoreModel'].init();
    },
    // STORE_INFO
    showMonthSelect: function showMonthSelect(type) {
      if (type === 'VISIT_REPORT') {
        this.exportType = 'VISIT_REPORT';
        this.exportTitle = this.$t("CPStoreList.export.visitRecord");
        this.gapMonth = 1;
      } else if (type === 'TIRE_SALES') {
        this.exportType = 'TIRE_SALES';
        this.exportTitle = this.$t("CPStoreList.export.otherInfo");
        this.gapMonth = 5;
      }
      this.monthVisible = true;
    }
  }
};